import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { I18nProvider, initLanguage, getLang } from './i18n';
import ErrorBoundary from './ErrorBoundary';

// Pierwsza wizyta: jezyk wg kraju adresu IP (spoza Polski -> angielski), zanim
// cokolwiek sie narysuje -- bez mrugniecia polska wersja. Potem juz z pamieci.
initLanguage(process.env.REACT_APP_API_URL || '').then((render) => {
  if (!render) return;   // przeladowanie w innym jezyku
  document.documentElement.lang = getLang();
  if (getLang() === 'en') document.title = 'HamLogger – Amateur radio logbook';
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<React.StrictMode><ErrorBoundary fullPage><I18nProvider><App /></I18nProvider></ErrorBoundary></React.StrictMode>);
});

// Rejestracja service workera (PWA / działanie offline) -- prosty, ręcznie
// napisany SW (public/service-worker.js), bez Workbox/build-time injection.
//
// WAŻNE -- automatyczne wykrywanie nowej wersji: samo Ctrl+F5 NIE
// gwarantuje, ze stary service worker zostanie zastapiony nowym od razu --
// SW ma własny cykl zycia, czesciowo niezalezny od zwyklego przeladowania
// strony. Bez ponizszej logiki user mogl zostac "uwiezony" na starej
// wersji apki (stary, już poprawiony kod wciaz działa z cache'a) i jedynym
// skutecznym rozwiazaniem bylo reczne wyczyszczenie danych strony (co
// przy okazji usuwa Cache Storage uzywany przez SW -- stad "czyszczenie
// cookies pomaga", choc to nie same cookies byly problemem).
//
// Rozwiazanie: gdy przegladarka wykryje i aktywuje NOWA wersje SW (event
// "controllerchange" -- odpalany gdy nowy SW przejmuje kontrole nad
// strona), automatycznie przeladowujemy strone RAZ, zeby od razu wczytać
// swiezy kod, bez czekania az user sam to zauwazy i zrobi to ręcznie.
// Zabezpieczenie przed petla przeladowan (gdyby cos poszlo nie tak):
// flaga w sessionStorage pozwala tylko jedno auto-przeladowanie na sesje.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then((registration) => {
      // Aktywnie sprawdzaj nowa wersje co 5 minut (gdy karta jest otwarta
      // dlugo) -- bez tego przegladarka sama sprawdza tylko przy nawigacji,
      // co przy karcie otwartej caly dzien moglo nigdy nie nastapic.
      setInterval(() => { registration.update().catch(() => {}); }, 5 * 60 * 1000);
    }).catch((err) => {
      console.warn('Service worker registration failed:', err);
    });

    // Zabezpieczenie przed wielokrotnym przeladowaniem w REAKCJI na ten sam
    // event -- "reloading" jest lokalna dla tego wczytania strony (po
    // window.location.reload() caly skrypt i tak sie odtworzy od zera).
    // NIE uzywamy tu flagi w sessionStorage "tylko raz na sesje" -- karta
    // tej apki bywa otwarta caly dzien (np. podczas aktywacji), a
    // "controllerchange" odpala sie z definicji tylko raz na FAKTYCZNA
    // zmiane kontrolera, wiec dodatkowy, trwaly guard tylko zaszkodziłby
    // (zablokowalby KOLEJNA, prawdziwa aktualizacje pozniej w tej samej,
    // dlugo otwartej karcie).
    //
    // WAZNE: NIE przeladowujemy automatycznie/bez ostrzezenia -- user moze
    // byc w trakcie wypelniania formularza QSO, a nagle przeladowanie
    // straciloby niezapisane dane. Zamiast tego wysylamy zdarzenie, ktore
    // App.js przechwytuje i pokazuje baner z mozliwoscia recznego
    // odswiezenia (kiedy user jest gotowy), na tej samej zasadzie co
    // baner synchronizacji kolejki offline.
    //
    // POPRAWKA (petla banera): "controllerchange" odpala sie TAKZE przy
    // PIERWSZYM przejeciu strony przez SW (kontroler: brak -> SW) -- np. zaraz
    // po "Odswiez teraz", ktore wyrejestrowuje SW i przeladowuje strone. To nie
    // jest nowa wersja, a baner wracal po kazdym odswiezeniu. Reagujemy tylko,
    // gdy strona JUZ miala kontrolera przy wczytaniu (prawdziwa podmiana SW).
    const hadController = !!navigator.serviceWorker.controller;
    let notified = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!hadController || notified) return;
      notified = true;
      window.dispatchEvent(new CustomEvent('sw-update-available'));
    });
  });
}
